import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

// jl-design-system
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import Modal from 'jl-design-system/components/modal/Modal';
import CircularCountdown from 'jl-design-system/components/circular-countdown/CircularCountdown';

// redux
import { connect } from 'react-redux';
import {
  refreshSession,
  getSessionTimeoutValues,
} from '../../redux/actions/app/appActions';

// constant
import appConstants from '../../constants/appConstants';

import styles from './session-timeout-modal.scss';

export class SessionTimeoutModal extends PureComponent {

  static propTypes = {
    refreshSession: PropTypes.func,
    sessionExpiryData: PropTypes.shape({}),
    sessionWarningAfterTime: PropTypes.number,
  };

  static defaultProps = {
    refreshSession: window.defaultFunc,
    sessionExpiryData: undefined,
    sessionWarningAfterTime: undefined,
  };

  render() {
    const {
      refreshSession,
      sessionExpiryData,
      sessionWarningAfterTime,
    } = this.props;

    const headerText = 'Your session is about to expire in:';

    return (
      <Modal
        a11yHeader={headerText}
        className={styles.modal}
        isOpen
        onClose={refreshSession}
        rootId={appConstants.ROOT}
      >
        <h2 className={styles.header}>{headerText}</h2>
        <CircularCountdown
          className={styles.circularCountdown}
          total={
            get(sessionExpiryData, 'sessionExpiresIn') - sessionWarningAfterTime
          }
        />

        <PrimaryButton
          className={styles.continue}
          onClick={refreshSession}
        >
          Continue with checkout
        </PrimaryButton>
      </Modal>
    );
  }
}

export function mapStateToProps(state) {
  return getSessionTimeoutValues(state);
}

export function mapDispatchToProps() {
  return {
    refreshSession,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(SessionTimeoutModal);
